import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { AssetDoc, CustomerDoc } from '@livekatsomo/models';
import Box from '@mui/material/Box';
import { CustomerForm, CustomerFormProps } from './CustomerForm';
import { useTranslation } from 'next-i18next';

/**
 * Props for the CustomerDialog component
 */
export interface CustomerDialogProps {
  /** Whether the dialog is open or not */
  open: boolean;
  /** The customer to edit or add */
  customer?: CustomerDoc;
  /** The assets to display in the form */
  assets?: AssetDoc[];
  /** Function to call when the dialog is closed */
  onClose: () => void;
  /** Function to validate the customer slug */
  onValidateSlug: CustomerFormProps['onValidateSlug'];
  /** Function to call when the form is submitted */
  onSubmit: CustomerFormProps['onSubmit'];
}

/**
 * A dialog component for adding or editing a customer
 */
export function CustomerDialog({
  open: isOpen,
  customer,
  assets,
  onClose,
  onSubmit,
  onValidateSlug,
}: CustomerDialogProps) {
  const { t } = useTranslation();
  return (
    <Dialog scroll="body" open={isOpen} onClose={onClose} fullWidth>
      <Box sx={{ position: 'relative' }}>
        <DialogTitle>
          {customer ? t('Edit Customer') : t('Add Customer')}
        </DialogTitle>
        <CustomerForm
          assets={assets}
          customer={customer}
          onClose={onClose}
          onValidateSlug={onValidateSlug}
          onSubmit={onSubmit}
        />
      </Box>
    </Dialog>
  );
}

export default CustomerDialog;
